import { filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class MainStateService {
  private splitScreenSubject = new BehaviorSubject<boolean>(false);
  public splitScreenToggleClick$ = this.splitScreenSubject.asObservable();

  splitScreensStateToggle(){
    this.splitScreenSubject.next(!this.splitScreenSubject.value);
  }

 get splitScreenStateClicked$(){
   return this.splitScreenToggleClick$.pipe(filter(showSplitScreen => showSplitScreen == true))
 }
}